import Vue from 'vue'
import logger from '@/libraries/logger'

Vue.use(logger);